<template>
  <div class="mt-xl mx-xs">
    <ReferralShareHeader :referral-code="referralCode"/>
    <ReferralShareActions
      v-if="referralCampaign"
      class="mt-xl"
      :referral-url="`https://www.armoire.style/refer/${referralCode}`"
      :referral-campaign="referralCampaign"/>
    <ReferralShareLink
      class="mt-xl"
      :referral-code="referralCode"/>
    <TextLink
      class="d-block text-center mt-xl"
      target="_blank"
      type="a"
      href="https://support.armoire.style/legal/">
      Terms & Conditions
    </TextLink>
  </div>
</template>

<script setup>
import ReferralShareHeader from './ReferralShareHeader.vue'
import ReferralShareLink from './ReferralShareLink.vue'
import ReferralShareActions from './ReferralShareActions.vue'
import TextLink from '../global/sequin/TextLink.vue'

defineProps({
  referralCode: {
    type: String,
    required: true
  },
  referralCampaign: {
    type: Object,
    required: true
  }
})
</script>

